import { SingleCabinFormCapacityType } from "src/app/enums/single-cabin-form-capacity-type.enum";

export const environment = {
  production: true,
  // pathEcommerceGalavail: 'https://amazonia-platform-ecommerce.galavail.com'
  // Paths de aterrizaje en ecommerces
  pathEcommerceGalavail: 'https://amazonia-platform-ecommerce.galavail.com',
  geoIpServiceUrl: 'https://geoip.maxmind.com/geoip/v2.1/city/me',
  //pathEcommerceGalavail: 'https://royalgalapagos.com/ecommerce',
  appResource: {
    logoCruise: 'https://amazonia-manager.galavail.com/upload/fleet/',
    itinerario: 'https://amazonia-manager.galavail.com/upload/itinerario/',
    companyLogos: 'https://amazonia-manager.galavail.com/upload/company/logos/',
  },
  single_cabin_form_capacity: { type: SingleCabinFormCapacityType.FIXED, capacity: 2 },
  pathCRMroyal: 'https://services.galavail.com/gi-web/webresources/royalforms/requestavForm/'
};
